import { render, staticRenderFns } from "./FlatAdsBuy.vue?vue&type=template&id=28c1c762"
import script from "./FlatAdsBuy.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlatAdsBuy.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports